import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
];

export const LanguageSwitcher = () => {
  const { lang, setLang } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.2em] text-white/70 hover:text-white border border-white/10 hover:border-[#19A7E0]/50 rounded-sm transition-colors"
        data-testid="language-switcher-trigger"
      >
        <Globe className="w-3.5 h-3.5" />
        {lang}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-[#0A0D14] border border-white/10 rounded-sm min-w-[160px]"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className={`text-sm cursor-pointer ${
              lang === l.code ? "text-[#19A7E0]" : "text-white/80"
            } hover:bg-white/5 hover:text-white focus:bg-white/5 focus:text-white rounded-none`}
          >
            <span className="font-mono uppercase text-xs tracking-[0.2em] mr-3">{l.code}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
